// Google Tag Manager and GA4 tracking helper

// Tracking IDs
export const GTM_ID = "GTM-TS8L9DCH";
export const GA4_ID = "G-Y1SX9K0FXL";
// Note: Google Ads ID (AW-...) can be added here in the future if required.

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
    _trackingInitialized?: boolean;
  }
}

/**
 * Initializes GTM, GA4, and captures tel / whatsapp click events.
 * Idempotent, safe for SSR.
 */
export function initTracking(): void {
  if (typeof window === "undefined") {
    return;
  }

  if (window._trackingInitialized) {
    return;
  }
  window._trackingInitialized = true;

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];

  // Helper gtag function pushing to dataLayer
  function gtag(...args: unknown[]): void {
    window.dataLayer.push(args);
  }
  window.gtag = gtag;

  // 1. Google Tag Manager snippet
  window.dataLayer.push({
    "gtm.start": Date.now(),
    event: "gtm.js",
  });

  const gtmScript = document.createElement("script");
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(gtmScript);

  // 2. GA4 gtag.js script
  const ga4Script = document.createElement("script");
  ga4Script.async = true;
  ga4Script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(ga4Script);

  // GA4 config
  gtag("js", new Date());
  gtag("config", GA4_ID);

  // 3. Document-level click listener (capture phase) for tel and whatsapp links
  document.addEventListener(
    "click",
    (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      if (!target) return;

      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (!anchor) return;

      const href = anchor.getAttribute("href") || "";
      const linkText = (anchor.innerText || anchor.textContent || "").trim();
      const pagePath = window.location.pathname;

      if (href.startsWith("tel:")) {
        const phoneNumber = href.replace(/^tel:/i, "").trim();
        const payload = {
          event: "phone_call_click",
          phone_number: phoneNumber,
          page_path: pagePath,
          link_text: linkText,
        };
        window.dataLayer.push(payload);
        if (window.gtag) {
          window.gtag("event", "phone_call_click", payload);
        }
      } else if (href.includes("wa.me") || href.includes("api.whatsapp.com")) {
        const payload = {
          event: "whatsapp_click",
          page_path: pagePath,
          link_text: linkText,
        };
        window.dataLayer.push(payload);
        if (window.gtag) {
          window.gtag("event", "whatsapp_click", payload);
        }
      }
    },
    true
  );
}
